/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    container: "container",
    containerNone: "container--none-selection",
    icon: "dropdown-item-icon",
    iconEnd: "dropdown-item-icon--end",
    iconStart: "dropdown-item-icon--start",
    itemContent: "dropdown-item-content",
    link: "dropdown-link",
};
//# sourceMappingURL=resources.js.map
